export default class PersonalDetail {
  id!: number
  user!: number
  date_registered!: Date
  observation!: string
  legal!: number
}
